"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadLedgerKey = exports.queryHidWallets = exports.API = exports.registerTransportModule = exports.discoverDevices = void 0;
exports.default = API;
async function discoverDevices(accept = () => true) {
    const { discoverDevices } = await Promise.resolve().then(() => __importStar(require("./index")));
    return discoverDevices(accept);
}
exports.discoverDevices = discoverDevices;
async function registerTransportModule(module) {
    const { registerTransportModule } = await Promise.resolve().then(() => __importStar(require("./index")));
    return registerTransportModule(module);
}
exports.registerTransportModule = registerTransportModule;
async function API(transport) {
    const { LedgerApi } = await Promise.resolve().then(() => __importStar(require("./index")));
    return new LedgerApi(transport);
}
exports.API = API;
async function queryHidWallets() {
    const { queryHidWallets } = await Promise.resolve().then(() => __importStar(require("./index")));
    return queryHidWallets();
}
exports.queryHidWallets = queryHidWallets;
async function loadLedgerKey(api, path) {
    const { LedgerKey } = await Promise.resolve().then(() => __importStar(require("./index")));
    return LedgerKey.load(api, path);
}
exports.loadLedgerKey = loadLedgerKey;
//# sourceMappingURL=deferred.js.map